/*
 * ====================================================================
 * Grow Template
 * @package  Grow Template
 * @author   GrowGroup.Inc <info@grow-group.jp>
 * @license  MIT Licence
 * ====================================================================
 */

(function ($) {
  var growApp = function () {

  };

  /************************
   * please insert your code
   *************************/
  growApp.prototype.myCode = function () {

    growApp.prototype.anchorNav = function () {
      var anchorList = $('.c-anchor-nav');
      if (anchorList.length === ''){
        return false;
      }
      var anchorListItem = anchorList.find('.c-anchor-nav__item');
      if (anchorListItem.length < 3){
        anchorList.find('.row').addClass("is-justify-center");
      }
    }
  }

  $(function () {
    var app = new growApp();
    app.myCode();
    app.anchorNav();


  });
})(jQuery);
